module.exports = __webpack_public_path__ + "images/signup-panda.png";


//////////////////
// WEBPACK FOOTER
// ./images/signup-panda.png
// module id = 1131
// module chunks = 1